// Shared styles

.no-vertical-align {
  vertical-align: baseline;
}

.share_list {
  padding-inline-start: 0;
  margin: 0;

  li {
    list-style-type: none;
    display: inline-block;
    padding: 3px;
  }
}
